import { ProductsEffects } from './products.effect';

export const effects: any[] = [
  ProductsEffects,
];

export * from './products.effect';
